import { useEffect, useState } from "react";
import styles from "./App.module.css";
import Board from "./components/Board/Board";
import GameControls from "./components/GameControls/GameControls";
import useRegisterMines from "./utils/useRegister";
import { useSelector, useDispatch } from "react-redux";
import {
  beforePlay,
  wonGame,
  lostGame,
} from "../src/redux/types/userModeTypes";
import { resetGameData } from "./redux/slices/gameDataSlice";
import { changeMatchState } from "./redux/slices/userModeSlice";
import { inPlay } from "./redux/types/userModeTypes";
// import SoundTrackPlayer from "./components/Sounds/SoundTrackPlayer/SoundTrackPlayer";
import SoundEffectMuter from "./components/Sounds/SoundEffectMuter/SoundEffectMuter";

function App() {
  const dispatch = useDispatch();
  const registerMines = useRegisterMines();
  const userMode = useSelector((state) => state.userMode);
  const finishedTilesArray = useSelector((state) => state.finishedTilesArray);
  const gameSettings = useSelector((state) => state.gameSettings);
  const [timeoutID, setTimeoutID] = useState();
  const [hasTimeOut, setHasTimeOut] = useState(false);
  useEffect(() => {
    registerMines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allowToInitBoard = () =>
    userMode.userModeState === beforePlay &&
    (userMode.matchState === wonGame || userMode.matchState === lostGame) &&
    finishedTilesArray.array.length > 0 &&
    gameSettings.isInManualMode;

  const initBoard = () => {
    if (allowToInitBoard()) {
      dispatch(resetGameData());
      dispatch(changeMatchState(inPlay));
      clearTimeout(timeoutID);
      setHasTimeOut(false);
    }
  };

  useEffect(() => {
    if (allowToInitBoard()) {
      if (!hasTimeOut) {
        setHasTimeOut(true);
        const tempTimeoutID = setTimeout(() => {
          initBoard();
        }, 3000);
        setTimeoutID(tempTimeoutID);
      }
    }
    // eslint-disable-next-line
  }, [userMode.matchState]);

  return (
    <div
      onClick={() => {
        initBoard();
      }}
    >
      <div className={styles.soundsContainer}>
        {/* <SoundTrackPlayer url={music} /> */}
        <SoundEffectMuter />
      </div>
      <div className={styles.gameLayout}>
        <GameControls />
        <Board />
      </div>
    </div>
  );
}

export default App;
